import React, { useContext, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { brightStarSsoLogin } from "../API/index";
import Loader from "./Loader";
import { ThemeContext } from "../assets/theme/ThemeContext";
import {
  completeLogin,
  getDefaultLoginRedirect,
  getSafeInternalRedirect,
} from "../utils/auth";

const Sso = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { updateTheme } = useContext(ThemeContext);

  useEffect(() => {
    const token = searchParams.get("token");
    const redirectPath = getSafeInternalRedirect(searchParams.get("redirect"));
    const accessToken = localStorage.getItem("accessToken");

    const redirectAfterSso = (fallbackPath = "/") => {
      navigate(redirectPath || fallbackPath, { replace: true });
    };

    const loginWithSso = async () => {
      if (accessToken) {
        redirectAfterSso(getDefaultLoginRedirect());
        return;
      }

      if (!token) {
        toast.error("SSO token is missing.");
        redirectAfterSso("/");
        return;
      }

      try {
        const res = await brightStarSsoLogin(token);
        const defaultRedirectPath = await completeLogin(res, { dispatch, updateTheme });

        if (defaultRedirectPath) {
          redirectAfterSso(defaultRedirectPath);
        } else {
          toast.error("Unable to sign in with SSO.");
          redirectAfterSso("/");
        }
      } catch (err) {
        toast.error("Unable to sign in with SSO.");
        redirectAfterSso("/");
      }
    };

    loginWithSso();
  }, [dispatch, navigate, searchParams, updateTheme]);

  return <Loader />;
};

export default Sso;
